import { localized } from "@blocks/utils";
import { addFilter } from "@wordpress/hooks";

const setSectionDefaultWidth = () => {
	addFilter(
		"magazine-blocks.block.metadata",
		"magazine-blocks/update-section-default-width",
		(metadata) => {
			if ("magazine-blocks/section" === metadata.name) {
				metadata.attributes.width.default.desktop.value =
					localized.configs.editor["section-width"];
			}
			return metadata;
		}
	);
};

export default setSectionDefaultWidth;
